import React, { useContext } from "react";
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import {
    TreeContext,
    AttributeContext,
    ComponentContext,
} from "../../../Store";

// Elemente für Baum-Darstellung definieren wenn Suchfeld nicht benutzt wird (Aufruf über SearchList.js)

export function TreeItemsFromData({ items, pa }) {
    const tree = useContext(TreeContext);
    const attr = useContext(AttributeContext);
    const comp = useContext(ComponentContext);

    if (!items) return null;

    return items.map((treeItemData) => {
        const itemName = treeItemData.name;
        const children = treeItemData.children_objecttypes?.length > 0
            ? <TreeItemsFromData items={treeItemData.children_objecttypes} />
            : undefined;

        return (
            <TreeItem
                key={treeItemData.global_id}
                itemId={treeItemData.global_id}
                label={itemName}
                children={children}
                onClick={() => {
                    tree.setSelected(treeItemData);
                    tree.setSelectedItem(treeItemData.attribute);
                    attr.setIsSelected(false);
                    comp.setIsSelected(true);
                    comp.setName("");
                    comp.setCode("");
                    comp.setDesc("");
                    tree.setParent(pa);
                }}
            />
        );
    });
}
